import Vue from 'vue'
import App from 'App.vue'
import axios from 'axios'
import Auth from '@websanova/vue-auth'
import VueAuthHttp from '@websanova/vue-auth/drivers/http/axios.1.x'
import VueAuthRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x'
import VueAxios from 'vue-axios'
import Multiselect from 'vue-multiselect'
import ToggleButton from 'vue-js-toggle-button'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import router from '@/router'

// Componentes globais da aplicação
import Notification from '@/components/shared/Notification'
Vue.component('Notification', Notification)

Vue.use(VueAxios, axios)
Vue.use(ToggleButton)
Vue.component('multiselect', Multiselect)

Vue.config.productionTip = false
Vue.axios.defaults.baseURL = process.env.VUE_APP_ROOT_API
Vue.axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'

Vue.router = router

Vue.use(Auth, {
	auth: {
		request: function (req, token) {
			this.options.http._setHeaders.call(this, req, { 'repov4-token': token })
		},
		response: function (res) {
			const headers = res.data
			return headers.token
		}
	},
	fetchData: { url: '/usuarios/minha_conta', method: 'GET' },
	http: VueAuthHttp,
	router: VueAuthRouter,
	tokenDefaultName: 'repov4-token',
	rolesVar: 'perfil',
	authRedirect: { path: '/login' },
	forbiddenRedirect: { path: '/login' },
	parseUserData: function (data) {
		return data
	},
	refreshData: {
		enabled: false
	},
	tokenExpired: function () {
		return false
	}
})

new Vue({
	el: '#app',
	router,
	render: h => h(App)
}).$mount('#app')
